import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const DeleteUnit = ({ rideItems, setRideItems, index }) => {
  const Delete = (unitIdx) => {
    const r = [...rideItems];
    r.splice(unitIdx, 1);
    setRideItems(r);
  };

  return (
    <FontAwesomeIcon
      onClick={() => Delete(index)}
      style={{
        filter: "drop-shadow(0px 0px 1px black)",
        position: "absolute",
        top: 0,
        cursor: "pointer",
        zIndex: 1000,
        padding: "10px",
      }}
      size={"3x"}
      color={"white"}
      icon={faTimesCircle}
    />
  );
};

export default DeleteUnit;
